import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import handleValidation from "../../../Validation";

import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";

class ForCompaniesQuestionForm extends Component {
  state = {
    fullName: "",
    email: "",
    phoneNumber: "",
    errors: {},
    errorsdiv: false
  };

  submitDetails = event => {
    debugger;

    let formData = {
      first_name: this.refs.first_name.value,
      email: this.refs.email.value,
      contact: this.refs.contact.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] === true) {
      document.getElementById("companies").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("companies").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    return (
      <div className="question-form-section section-padding">
        <Container>
          <Row>
            <Col sm={{ size: 8, offset: 2 }}>
              <Row className="have-questions-form">
                <Col sm={{ size: 12 }}>
                  <h1 className="mt-5 mb-3 text-center">{this.props.title}</h1>
                  <hr className="heading-underline mb-5" />
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 6 }}>
                  <h3>{this.props.textTitle}</h3>
                  <p className="question-form-text">{this.props.text}</p>
                  <p className="question-form-text">
                    <FontAwesome
                      className="map-marker-alt"
                      name="map-marker-alt"
                    />{" "}
                    3550 Lenox Rd NE Suite 2100
                  </p>
                  <p className="question-form-text">
                    <FontAwesome className="phone" name="phone" />
                    404-474-4774
                  </p>
                  <p className="question-form-text">
                    <FontAwesome className="envelope" name="envelope" />{" "}
                    info@itslighthouse.com
                  </p>
                </Col>

                <Col className="white" sm={{ size: 6 }}>
                  <form
                    id="companies"
                    action=""
                    method=""
                    onSubmit={this.submitDetails.bind(this)}
                  >
                    <input type="hidden" name="oid" value="00D3i000000GUvA" />
                    <input type="hidden" name="lead_source" value="Website" />
                    <input
                      type="hidden"
                      name="00N3i00000Bm5C9"
                      value="Companies_website_v1"
                    />
                    <input
                      type="hidden"
                      name="retURL"
                      value="https://atlighthouse.com/thank-you"
                    />
                  

                    <label className="apply-now-labels" htmlFor="first_name">
                      Name<p className="required-symbol">{"*"}</p>
                    </label>
                    <input
                      id="first_name"
                      maxLength="60"
                      name="first_name"
                      className="input-form form-control"
                      size="20"
                      type="text"
                      ref="first_name"
                      placeholder="Full Name"
                    />
                    {this.state.errorsdiv === true ? (
                      <span className="error">
                        {this.state.errors["first_name"]}
                      </span>
                    ) : (
                      ""
                    )}
                    <br />

                    <label className="apply-now-labels" htmlFor="email">
                      Email<p className="required-symbol">{"*"}</p>
                    </label>
                    <input
                      id="email"
                      maxLength="80"
                      name="email"
                      size="20"
                      type="email"
                      className="input-form form-control"
                      ref="email"
                      placeholder="Email"
                    />
                    {this.state.errorsdiv === true ? (
                      <span className="error">
                        {this.state.errors["email"]}
                      </span>
                    ) : (
                      ""
                    )}
                    <br />

                    <label className="apply-now-labels" htmlFor="contact">
                      Phone Number<p className="required-symbol">{"*"}</p>
                    </label>
                    <input
                      id="contact"
                      maxLength="80"
                      minLength="10"
                      name="phone"
                      size="20"
                      type="text"
                      ref="contact"
                      className="input-form form-control"
                      placeholder="Phone Number"
                    />
                    {this.state.errorsdiv === true ? (
                      <span className="error">
                        {this.state.errors["contact"]}
                      </span>
                    ) : (
                      ""
                    )}
                    <br />

                    <label className="apply-now-labels" htmlFor="message">
                      Message
                    </label>
                    <textarea
                      id="00N3i00000Bklln"
                      name="00N3i00000Bklln"
                      rows="6"
                      type="text"
                      wrap="soft"
                      className="apply-now-inputs form-control"
                      placeholder="We'd love to hear from you."
                    ></textarea>
                    <br />
                    <div>
                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn-secondary"
                      />
                    </div>
                  </form>
                  <p className="privacy-terms mt-0">
                    <i>
                      By providing your email, you agree to our{" "}
                      <u>
                        <Link style={{ color: "white" }} to="/privacy-policy">
                          privacy policy
                        </Link>
                      </u>{" "}
                      and{" "}
                      <u>
                        <Link style={{ color: "white" }} to="/terms-of-service">
                          terms of conditions
                        </Link>
                      </u>
                    </i>
                    .
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ForCompaniesQuestionForm;
